import React, { memo } from "react";
import Comments from "shared/components/organisms/GlobalComments";
import { Container } from "./styles";



const CommentsCourseLandingPage = ({ course }) => {
  const commentableId = course.id;

  const statusComments = {
    status_read: course?.status_read_comments,
    status_write: course?.status_write_comments,
    status_visible: course?.status_comments,
    has_enrollment: course?.has_enrollment,
    reasons_any_description_only_enrolled_users: [course],
  };

  return (
    <Container>
      <Comments
        commentableType="Vico068\CourseTools\Course"
        commentableId={commentableId}
        statusComments={statusComments}
      />
    </Container>
  );
};

export default memo(CommentsCourseLandingPage);
